module.exports = __webpack_public_path__ + "img/article74.15103fc6.jpg";